// extracted by mini-css-extract-plugin
export default {"toastMain":"ToastMessage_toastMain__RJn-u","success":"ToastMessage_success__gK6Dt","error":"ToastMessage_error__CGTUr","caution":"ToastMessage_caution__yNxwa"};